<template>
  <div class="wrap">
    <!-- browser-suggestion -->
    <browser-suggestion></browser-suggestion>
    <!-- browser-suggestion -->

    <div class="wrapper after-wrapper">
      <!-- banner图 -->
      <div class="home-banner-wrap" v-show="!userLogin">
        <banners class="home-banner"></banners>
      </div>
      <!-- /banner图 -->

      <!-- 首页个人信息 -->
      <div class="login-info" v-show="userLogin">
        <div class="user-banner">
          <img src="../../assets/image/home-login.png" alt="" />
        </div>

        <div class="right-user">
          <div class="user-profile">
            <div class="portrait">
              <div class="avatar-wrap">
                <img :src="AvatarImg" alt="" />
              </div>
              <div class="welcome">
                <div class="name">
                  {{ userInfo.Name }}
                  <div class="auth" v-show="authFlag">
                    <el-tag size="mini">内部员工</el-tag>
                  </div>
                </div>
                <div class="hint">欢迎回来~</div>
              </div>
            </div>

            <div class="my-func">
              <div class="my-func-item" @click="navClick('/resumeList')">
                <!-- <img src="../../assets/image/jianli.png" alt="" class="img" /> -->
                <div class="func-icon jianli"></div>
                <div class="text">我的简历</div>
              </div>
              <div class="my-func-item" @click="navClick('/applyList')">
                <!-- <img src="../../assets/image/yingpin.png" alt="" class="img" /> -->
                <div class="func-icon yingpin"></div>
                <div class="text">我的应聘</div>
              </div>
              <div class="my-func-item" @click="navClick('/myNews')">
                <!-- <img src="../../assets/image/xiaoxi.png" alt="" class="img" /> -->
                <div class="func-icon xiaoxi"></div>
                <div class="text">我的消息</div>
              </div>
              <div class="my-func-item" @click="navClick('/auth')">
                <div class="func-icon auth"></div>
                <div class="text">身份认证</div>
              </div>
              <div class="my-func-item" @click="quit">
                <!-- <img src="../../assets/image/quit.png" alt="" class="img" /> -->
                <div class="func-icon quit"></div>
                <div class="text">退出登录</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /首页个人信息 -->

      <!-- 主页导航菜单 -->
      <div class="nav-link">
        <div class="nav-child" @click="navClick('/announcement')">
          <div class="child-l child-l1"></div>
          <div class="child-r">招聘公告</div>
        </div>
        <div class="nav-child" @click="navClick('/ofPublic')">
          <div class="child-l child-l2"></div>
          <div class="child-r">招聘公示</div>
        </div>
        <div class="nav-child" @click="navClick('/campus')">
          <div class="child-l child-l3"></div>
          <div class="child-r">校园招聘</div>
        </div>
        <div class="nav-child" @click="navClick('/social')">
          <div class="child-l child-l4"></div>
          <div class="child-r">社会招聘</div>
        </div>
        <div class="nav-child" @click="navClick('/internal')">
          <div class="child-l child-l5"></div>
          <div class="child-r">内部招聘</div>
        </div>
      </div>
      <!-- /主页导航菜单 -->

      <!-- 最新公告 -->
      <div class="last-notice">
        <div class="card-panel">
          <div class="card-title">
            <div class="title">
              <a>最新公告公示</a>
            </div>
          </div>
          <div class="card-body">
            <div class="card-item" v-for="(item, index) in announcement" :key="index" @click="link(item)">
              <div class="left">
                {{ item.title }}
              </div>
              <div class="date">
                {{ item.rlsdate.split(" ")[0] }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /最新公告 -->

      <!-- 最新岗位 -->
      <div class="last-post">
        <div class="card-panel">
          <div class="card-title">
            <div class="title">
              <a>最新岗位</a>
            </div>
            <!-- <div class="right">
              <ul>
                <li><a>校园招聘</a></li>
                <li><a>社会招聘</a></li>
                <li><a>内部招聘</a></li>
              </ul>
            </div> -->
          </div>
          <div class="card-body">
            <div class="card-item" v-for="(item, index) in jobsList" :key="index"
              @click="toHomeList(item.oid, item.zpgw, item.zpdw)">
              <div class="apply-btn">
                <el-button type="primary" size="mini" @click.stop.prevent="
                  applyJob(item.oid, item.zpgw, item.zpdw, item.zpxs)
                  ">申请</el-button>
              </div>
              <div class="title">{{ item.zpgw }}</div>
              <div class="corp">{{ item.zpdw }}</div>
              <!-- <div class="corp"></div> -->
              <div class="desc">
                <div class="tip">{{ item.gzdd }} 招聘人数：{{ item.zprs }}</div>
                <div class="date">
                  <span>报名截止日期</span>：{{ item.jzrq }}
                </div>
              </div>
              <div class="foot">
                <span>{{ item.xl }} | {{ item.zy }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- /最新岗位 -->

      <!-- <resume
                :resumeFlag="resumeFlag"
                v-if="resumeFlag.flag"
                :backRoute="resumeBackRoute"
            >
            </resume> -->
      <resume-list :resumeFlag="resumeFlag" v-if="resumeFlag.flag" :backRoute="resumeBackRoute"></resume-list>
    </div>
  </div>
</template>

<script>
import banners from "../common/banner";
// import resume from "../common/resume";
import resumeList from "../common/resumelist";
import { initData, jobsData } from "../request/api";
import { isLogin, getLoginUser } from "../../utils/auth";
import { doLogout } from "../../utils/sdk";
import AvatorMan from "../../assets/image/avator_man.png";
import AvatarWoman from "../../assets/image/avatar_woman.jpg";
import { mapMutations, mapActions, mapState } from "vuex";
import BrowserSuggestion from "../common/BrowserSuggestion";
import { MessageBox } from "element-ui";
export default {
  components: {
    banners,
    // resume,
    BrowserSuggestion,
    resumeList,
  },
  name: "home",
  data() {
    return {
      resumeBackRoute: {
        path: "/",
      },
      announcement: [],
      jobsList: [],
      noticeName: "",
      resumeFlag: {
        flag: false,
      }, //简历弹窗
      Data: {
        nameLike: "",
        type: "1",
        pageNo: "1",
        pageSize: "10",
        isIndex: true,
      },
      authFlag: false,
      AvatarImg: AvatorMan,
      userInfo: {},
      currentTime: new Date().getTime(),
      timeOut: "",
      // 岗位信息
      // SelectData: {
      //   postoid: "",
      //   postname: "",
      //   orgname: "",
      // },
    };
  },
  mounted() {

    this.initData();
    this.jobsData();
    //未登录会报错,JSON解析问题,不影响正常使用

    if (isLogin()) {
      this.userInfo = getLoginUser();
      if (this.userInfo.hrpsn > 0) {
        this.authFlag = true;
      }
      if (this.userInfo.Sex == "女") {
        this.AvatarImg = AvatarWoman;
      } else {
        this.AvatarImg = AvatorMan;
      }
    }
  },
  methods: {
    ...mapMutations([
      // 全局路由生产
      "pushBackRoute",
      // 全局职业选择
      "setResumeSelectData",
      "clearResumeSelectData",
    ]),
    ...mapActions([
      // 全局路由消费
      "popBackRoute",
    ]),
    initData() {
      initData().then((response) => {
        if (response.code == "1") {
          this.announcement = response.data;
        }
      });
    },
    jobsData() {
      jobsData(this.Data).then((response) => {
        if (response.code == "1") {
          this.jobsList = response.data;
        }
      });
    },
    navClick(url) {
      // navClick
      if (url == "/resumeList") {
        // 重置全局选择的数据
        this.clearResumeSelectData();
      }
      // 跳转nav
      this.$router.push(url);
    },
    //跳转岗位详情
    toHomeList(postoid, postname, orgname) {
      // this.$router.push(
      //   `/postList?oid=${postoid}&postoid=${postoid}&orgname=${orgname}&postname=${postname}`
      // );
      this.$router.push(
        `/postList?oid=${postoid}`
      );
    },
    link(item) {
      if (item.notice == '公示') {
        this.$router.push(`/ofPublicList?id=${item.oid}&stitle=${item.title}`);
      } else {
        // 跳转二级页
        this.$router.push(`/recruiList?id=${item.oid}&stitle=${item.title}`);
        // this.$router.push(`/recruiList?id=${oid}`);
      }
    },
    quit() {
      // 退出
      doLogout().then((res) => {
        this.$router.push("/login");
      });
    },
    //申请职位
    applyJob(postoid, postname, orgname, zpxs) {
      if (!isLogin()) {
        this.$router.push("/login");
        return;
      }
      // 设置全局返回路由
      this.pushBackRoute({
        name: "home",
      });
      this.userInfo = getLoginUser();
      //判断当前岗位是否是内部招聘
      if (zpxs.indexOf("3") != -1) {
        //如果是内部招聘，需要判断是否已进行身份认证
        if (this.userInfo.hrpsn == "" || this.userInfo.hrpsn <= 0) {
          MessageBox.confirm("当前职位为内部招聘，请先进行身份认证。", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.$router.push("/auth");
          });
          return;
        }
      }
      // 设置选中数据
      this.setResumeSelectData({
        oid: postoid,
        postoid: postoid,
        postname: postname,
        orgname: orgname,
      });
      // 判断用户是否登录
      this.resumeFlag.flag = true;
    },
  },
  computed: {
    // 用户是否登录
    userLogin: function () {
      return isLogin();
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  min-width: 320px;

  .wrapper {
    width: auto;
    min-width: 320px;
    margin: 0 auto;
    padding-left: 24px;
    padding-right: 24px;

    // login info

    .login-info {
      // 移动不显示
      display: none;
      height: 320px;
      margin-bottom: 24px;
      // display: flex;

      .user-banner {
        height: 100%;
        flex: auto;
        z-index: 11;

        img {
          height: 100%;
          width: 100%;
          // border-radius: 24px;
          // border-top-left-radius: 24px;
          // border-top-right-radius: 4px;
          // border-bottom-left-radius: 24px;
          border-bottom-right-radius: 48px;
        }
      }

      .right-user {
        height: 100%;
        width: 432px;
        flex: 0 0 auto;
        z-index: 10;
        position: relative;
      }

      .user-profile {
        background: #fff;
        // background: #CCC;
        // background: linear-gradient(to right, #ffa39e, #4bc0eb);
        height: 100%;
        display: flex;
        flex-direction: column;
        // border-top-right-radius: 24px;
        // border-bottom-right-radius: 24px;
        margin-left: -48px;
        padding-left: 60px;
        padding-top: 12px;
        padding-right: 12px;
        padding-bottom: 12px;

        .portrait {
          flex: auto;
          display: flex;
        }

        .avatar-wrap {
          flex: 0 0 auto;
          height: 128px;
          width: 108px;
          margin-top: 12px;

          img {
            display: block;
            height: 100%;
            width: 100%;
            // border-radius: 8px;
          }
        }

        .welcome {
          margin-top: 48px;
          margin-left: 12px;
          flex: auto;

          .name {
            font-size: 18px;

            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;

            .auth {
              display: inline-flex;
            }
          }

          .hint {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

        .my-func {
          flex: 0 0 auto;
          position: relative;
          display: flex;
          justify-content: space-between;

          .text {
            line-height: 22px;
          }
        }

        .my-func-item {
          width: 84px;
          height: 84px;
          text-align: center;
          cursor: pointer;
          box-sizing: border-box;
        }

        .my-func-item:active {
          opacity: 0.5;
        }

        .func-icon {
          width: 40px;
          height: 40px;
          margin-left: 22px;
          margin-top: 12px;

          &.jianli {
            background: url("../../assets/image/jianli.png");
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 100% 100%;
          }

          &.yingpin {
            background: url("../../assets/image/yingpin.png");
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 100% 100%;
          }

          &.xiaoxi {
            background: url("../../assets/image/xiaoxi.png");
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 100% 100%;
          }

          &.auth {
            background: url("../../assets/image/auth.png");
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 100% 100%;
          }

          &.quit {
            background: url("../../assets/image/quit.png");
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 100% 100%;
          }
        }
      }
    }

    // /login info

    // home-banner
    .home-banner-wrap {}

    .home-banner {
      margin-bottom: 24px;
      height: 128px;

      ::v-deep {
        .el-carousel .img-item {
          display: block;
          height: 128px;
          width: 100%;
        }

        .el-carousel .el-carousel__container {
          height: 128px;
        }
      }
    }

    // home-banner

    // .nav-link
    .nav-link {
      display: flex;
      justify-content: space-between;
      margin-bottom: 24px;
      // min-height: 52px;
      background: #fff;
      // background: linear-gradient(to right, #ffa39e, #4bc0eb);
      // background: #CCC;
      padding: 12px;
      // border-radius: 12px;
      // border-bottom-left-radius: 24px;
      // border-bottom-right-radius: 24px;

      .nav-child {
        // width: 136px;
        border-radius: 4px;
        cursor: pointer;
        // background: #fff;
        background: rgba(255, 255, 255, 0.8);
        // background: #CCC;
        font-size: 12px;
        // color: #999;
        padding: 8px;

        .child-l {
          display: block;
          width: 32px;
          height: 32px;
          border-radius: 4px;
          // float: left;
          // margin-top: 12px;
          margin-left: auto;
          margin-right: auto;
          // border: 1px solid rgba(0, 0, 0, 0.1);
          margin-bottom: 6px;
        }

        .child-r {
          // display: none;
          // margin-left: 60px;
          // margin-top: 12px;
          // line-height: 48px;
          // padding-left: 8px;
          text-align: center;
          line-height: 32px;
        }

        .child-l1 {
          background: url("../../assets/image/tb-1.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          // background-color: #e6c97c;
        }

        .child-l2 {
          background: url("../../assets/image/tb-2.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          // background-color: #34ba88;
        }

        .child-l3 {
          background: url("../../assets/image/tb-3.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          // background-color: #2b96f1;
        }

        .child-l4 {
          background: url("../../assets/image/tb-4.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          // background-color: #8c88cd;
        }

        .child-l5 {
          background: url("../../assets/image/tb-5.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          // background-color: #69c5e4;
        }
      }

      .nav-child:hover {
        background: #0089d0;

        .child-l {
          // border: 2px solid rgba(255, 255, 255, 0.8);
        }

        .child-r {
          color: #fff;
          color: rgba(255, 255, 255, 0.8);
        }

        .child-l1 {
          background: url("../../assets/image/tb-1h.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          // background-color: #fff;
        }

        .child-l2 {
          background: url("../../assets/image/tb-2h.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          // background-color: #fff;
        }

        .child-l3 {
          background: url("../../assets/image/tb-3h.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          // background-color: #fff;
        }

        .child-l4 {
          background: url("../../assets/image/tb-4h.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          // background-color: #fff;
        }

        .child-l5 {
          background: url("../../assets/image/tb-5h.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          // background-color: #fff;
        }
      }
    }

    // .nav-link

    // 最新公告
    .last-notice {
      margin-bottom: 24px;

      .card-panel {
        // border-radius: 24px;
        // border-bottom-left-radius: 24px;
        // border-top-right-radius: 24px;
      }

      .card-body {
        padding: 12px 6px;
      }

      .card-item {
        position: relative;
        display: flex;
        line-height: 32px;
        padding-left: 12px;
        padding-right: 12px;
        cursor: pointer;
        justify-content: space-between;
        // border-bottom: 1px solid #eee;
        margin-bottom: 6px;
        // border-top-right-radius: 24px;
        // border-bottom-left-radius: 24px;
        // border-bottom-right-radius: 4px;
        // border-top-left-radius: 4px;
        // background: linear-gradient(to left, #ffa39e, #4bc0eb);
        // background: #70f3ff;

        // &::after  {
        //   position: absolute;
        //   left: 0;
        //   right: 0;
        //   bottom: -6px;
        //   height: 1px;
        //   content: '';
        //   background: #CCC;
        // }

        .left {
          flex: auto;

          word-wrap: break-word;
        }

        .date {
          flex: 0 0 auto;
          margin-left: 12px;
        }

        &:last-child {
          border-bottom: none;

          &::after {
            display: none;
          }
        }
      }

      .card-item:hover {
        background: #0089d0;
        // background: linear-gradient(to right, #ffa39e, #4bc0eb);
        color: #fff;
        color: rgba(255, 255, 255, 0.8);
      }
    }

    // /最新公告

    // 最新岗位
    .last-post {
      margin-bottom: 24px;

      .card-panel {
        // border-radius: 24px;
        // border-bottom-left-radius: 24px;
        // border-top-right-radius: 24px;
      }

      .card-title {
        .right {
          float: right;
          margin-right: 12px;
        }

        ul {
          font-size: 14px;
          margin: 0;
          padding: 0;
          list-style: none;
        }

        li {
          display: inline-block;
          vertical-align: middle;
        }

        li a {
          margin-left: 8px;
          position: relative;
        }

        li a::after {
          position: absolute;
          left: -5px;
          top: 0;
          bottom: 0;
          content: "";
          width: 2px;
          background: rgba(0, 0, 0, 0.8);
        }

        li:first-child a::after {
          display: none;
        }
      }

      .card-body {
        padding: 12px;
      }

      .card-item {
        position: relative;
        margin-bottom: 12px;
        // background: #CCCCCC;
        background: #edf1f7;
        // background: linear-gradient(to right, #ffccc7,#CCC);
        // border: 1px solid #eee;
        // border-radius: 24px;
        padding-left: 12px;
        padding-right: 12px;
        padding-top: 12px;
        padding-bottom: 12px;
        cursor: pointer;

        .title {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 16px;
          color: #0089d0;
        }

        .corp {
          margin-bottom: 8px;
        }

        .desc {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;

          .tip {
            display: block;
            // width: 100%;
            margin-right: 12px;
            margin-bottom: 8px;
          }

          .date {
            display: block;
            // width: 100%;
            margin-bottom: 8px;
          }
        }

        .foot {
          font-size: 12px;
        }

        .apply-btn {
          // 按钮在移动下不显示
          display: none;
          position: absolute;
          right: 12px;
          top: 12px;

          .el-button {
            // border-radius: 12px;
            // background: linear-gradient(to right, #ffa39e, #f5222d);
            border-radius: 0;
            border: none;
            color: rgba(255, 255, 255, 0.8);
            height: 32px;
            width: 80px;
            padding: 0;
            font-size: 14px;

            &:hover {
              // background: linear-gradient(to left, #ffa39e, #f5222d);
            }

            &:active {
              opacity: 0.5;
            }
          }
        }
      }

      .card-item:hover {
        // .title {
        //   color: #0089D0;
        // }
        // border: 1px solid #0089D0;
        // background: linear-gradient(to right, #ffa39e, #4bc0eb);
        // color: rgba(255, 255, 255, 0.8);
        // border: 1px solid rgba(255, 255, 255, 0.8);

        .title {}
      }

      .card-item:active {
        opacity: 0.5;
      }
    }

    // /最新岗位
  }
}

@media screen and (min-width: 320px) {

  // wrap
  .wrap {
    width: 100%;

    .wrapper.after-wrapper {
      width: 100%;
      margin: 0 auto;

      // login info
      .login-info {
        height: 240px;
        width: 100%;

        .user-banner {
          display: none;
        }

        .right-user {
          width: 100%;
        }

        .user-profile {
          .my-func {
            .text {
              display: none;
            }
          }

          .my-func-item {
            width: 40px;
            height: 40px;
            text-align: center;
            border: none;
            cursor: pointer;
            border: none;
          }

          .func-icon {
            width: 32px;
            height: 32px;
            margin-left: 4px;
            margin-top: 4px;
          }
        }
      }

      // /login info
    }
  }

  // wrap
}

@media screen and (min-width: 480px) {}

/* 移动 */
@media screen and (min-width: 576px) {

  // wrap
  .wrap {
    width: 100%;

    .wrapper.after-wrapper {
      width: 100%;
      margin: 0 auto;

      .login-info {
        height: 240px;

        .user-banner {
          display: block;
        }

        .right-user {
          width: 240px;
        }
      }

      // home-banner
      .home-banner {
        height: 154px;

        ::v-deep {
          .el-carousel .img-item {
            display: block;
            height: 154px;
            width: 100%;
          }

          .el-carousel .el-carousel__container {
            height: 154px;
          }
        }
      }

      // home-banner

      // nav-link
      .nav-link {
        // border-radius: 24px;

        .nav-child {
          // padding-top: 8px;
          // padding-bottom: 8px;
          border-radius: 32px;

          .child-l {
            float: left;
            margin-bottom: 0;
          }

          .child-r {
            margin-left: 42px;
            margin-right: 12px;
            // line-height: 48px;
          }
        }
      }

      // / nav-link
    }
  }

  // wrap
}

/* 平板 */
@media screen and (min-width: 768px) {

  // wrap
  .wrap {
    width: 100%;

    .wrapper.after-wrapper {
      width: 100%;
      margin: 0 auto;

      .login-info {
        // 显示
        display: flex;
        height: 280px;

        // 文字消失
        .right-user {
          width: 260px;
        }
      }

      // home-banner
      .home-banner {
        height: 204px;

        ::v-deep {
          .el-carousel .img-item {
            display: block;
            height: 204px;
            width: 100%;
          }

          .el-carousel .el-carousel__container {
            height: 204px;
          }
        }
      }

      // home-banner

      // .nav-link
      .nav-link {
        .nav-child {
          // padding-left: 24px;
          // padding-right: 24px;
          padding-top: 12px;
          padding-bottom: 12px;

          .child-l {}

          .child-r {
            font-size: 14px;
            // margin-left: 72px;
            // margin-right: 12px;
          }
        }
      }

      // .nav-link

      // 最新岗位
      .last-post {
        .card-item {
          .apply-btn {
            // 按钮在移动下不显示
            display: block;
          }
        }
      }
    }
  }

  // wrap
}

/* PC */
@media screen and (min-width: 992px) {

  // wrap
  .wrap {
    width: 100%;

    .wrapper.after-wrapper {
      width: 100%;
      margin: 0 auto;

      .login-info {
        .right-user {
          width: 386px;
        }

        .user-profile {
          .my-func {
            flex: 0 0 auto;
            position: relative;
            display: flex;
            justify-content: space-between;

            .text {
              display: block;
              line-height: 22px;
            }
          }

          .my-func-item {
            width: 84px;
            height: 84px;
            text-align: center;
            // border: 1px solid #eee;
            cursor: pointer;
            box-sizing: border-box;
          }

          .my-func-item:hover {
            // border: 1px solid #0089D0;
            color: #0089d0;
            // color: rgba(255, 255, 255, 0.8);

            .func-icon {
              opacity: 0.8;
            }
          }

          .my-func-item:active {
            opacity: 0.5;
          }

          .func-icon {
            width: 40px;
            height: 40px;
            margin-left: 22px;
            margin-top: 12px;
          }
        }
      }

      // home-banner
      .home-banner {
        height: 260px;

        ::v-deep {
          .el-carousel .img-item {
            display: block;
            height: 260px;
            width: 100%;
          }

          .el-carousel .el-carousel__container {
            height: 260px;
          }
        }
      }

      // home-banner

      // .nav-link
      .nav-link {
        .nav-child {
          .child-l {
            // width: 52px;
            // height: 52px;
          }

          .child-r {
            // margin-left: 52px;
            font-size: 16px;
            // line-height: 52px;
            // margin-left: 84px;
            // margin-right: 20px;
          }
        }
      }

      // .nav-link
    }
  }

  // wrap
}

@media screen and (min-width: 1200px) {

  // wrap
  .wrap {
    width: 100%;

    .wrapper.after-wrapper {
      margin: 0 auto;
      padding-left: 0;
      padding-right: 0;

      .login-info {
        height: 320px;
        width: 1200px;
        margin-left: auto;
        margin-right: auto;
      }

      // home-banner
      .home-banner {
        height: 320px;
        margin-left: 24px;
        margin-right: 24px;

        ::v-deep {
          .el-carousel .img-item {
            display: block;
            height: 320px;
            width: 100%;
          }

          .el-carousel .el-carousel__container {
            height: 320px;
          }
        }
      }

      // home-banner

      .right-user {
        width: 486px;
      }

      // .nav-link
      .nav-link {
        width: 1200px;
        margin-left: auto;
        margin-right: auto;

        .nav-child {
          .child-l {
            // width: 64px;
            // height: 64px;
          }

          .child-r {
            // margin-left: 112px;
            // margin-right: 36px;
            font-size: 16px;
            font-weight: bold;
            // line-height: 64px;
          }
        }
      }

      // .nav-link

      // last-notice
      .last-notice {
        width: 1200px;
        margin-left: auto;
        margin-right: auto;
      }

      // last-post
      .last-post {
        width: 1200px;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }

  // wrap
}
</style>
